import { Injectable } from '@angular/core';
import { CompanyDTO, CompanyToInviteDTO, CPVDTO } from '../../api/plyca-dtos-v2';
import { FormConfig, FormConfigHelper } from '../../components/forms/form.objects';
import { formElementComponent } from '../../components/forms/formElement.component';

@Injectable()
export class ProcurementProjectAYMADCSDAValidations implements FormConfigHelper {
  constructor() { }


  // tslint:disable-next-line: member-ordering
  private static isGoods(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isGoods =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '02<>TIPOEXPTE';
      return isGoods;
    }
    return false;
  }

  // tslint:disable-next-line: member-ordering
  private static isServices(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isServices =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '04<>TIPOEXPTE';
      return isServices;
    }
    return false;
  }

  public enabledBudgetTotalTaxes(model: any) {
    return true;
  }






  // PANEL PRESUPUESTOS

  public isVisibleWorkProgramCSDA(model: any) {
    return ProcurementProjectAYMADCSDAValidations.isServices(model);
  }

  public isGoodsOrServicesCSDA(model: any) {
    let isGoods = ProcurementProjectAYMADCSDAValidations.isGoods(model);
    let isServices = ProcurementProjectAYMADCSDAValidations.isServices(model);
    return isGoods || isServices;
    //return true;
  }

  public isServicesCSDA(model: any) {
    return ProcurementProjectAYMADCSDAValidations.isServices(model);
  }






  public lotNumberSDA(model: any) {
    let lotNumber = '';
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      lotNumber = model?.procurementProjectAM?.breakdownLot?.lots[0].lotNumber;
    }
    return lotNumber;
  }

  public lotDescriptionSDA(model: any) {
    let description = '';
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      return model?.procurementProjectAM?.breakdownLot?.lots[0].description;
    }
    return description;
  }



  public isApportioned_SDA(model: any) {
    let isApportioned = false;
    if (model.procurementProjectAM) {
      isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    }
    if (model.contractingSystem?.originalContractingSystemLotID?.lotId != 0) {
      isApportioned = true;
    }
    return isApportioned;
  }


  public visibleHarmonizedRegulationCSDA(model: any) {
    let isServices = false;
    if (model.classification && model.classification.typeCode) {
      isServices = (model.classification.typeCode === undefined || model.classification.typeCode === null)
        ? false
        : model.classification.typeCode.identifier === '04<>TIPOEXPTE';
    }
    if (isServices) {
      return true;
    }

    return false;

  }




  // FUNCIONES CSDA
  private static isNoTaxCSDA(model: any) {

    let noTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier === '0<>TIPO_IMPUESTO');

    return noTax;
  }

  private roundCSDA(value: number, digits = 2): number {
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }

  public updateTotalAmountCSDA(model: any) {
    let total = (model.budget.amountExcludingTaxes || 0) + (model.budget.totalTaxes || 0);
    // let digits = 2;
    // let multiplier = Math.pow(10, digits);
    model.budget.totalAmount = this.roundCSDA(total);
  }

  public updateBudgetDataCSDA(model: any): void {
    // actualizar total impuesto
    this.updateBudgetTotalTaxesCSDA(model);
    // actualizar importe final
    this.updateTotalAmountCSDA(model);
    // Se actualiza el desplegable de Calculo Manual
    this.updatedBudgetTaxTypeCSDA(model);
    // Se actualiza el desplegable de tipo impositivo
    this.updatedTaxRate(model);

  }

  private updateBudgetTotalTaxesCSDA(model: any) {
    if (model.budget?.taxType?.identifier) {
      if (ProcurementProjectAYMADCSDAValidations.isNoTaxCSDA(model)) {
        // Exento de IVA
        model.budget.totalTaxes = 0;
        model.budget.taxRate = '';
      } else if (model.budget.taxType.identifier !== '998<>TIPO_IMPUESTO' && model.budget.taxType.identifier !== '1<>TIPO_IMPUESTO'
        && !model.budget.manualCalculation) {
        // no es Varios Tipos, ni  IVAincluido
        model.budget.totalTaxes = this.roundCSDA((model.budget.taxType?.properties?.PORCENTAJE || 0)
          * (model.budget.amountExcludingTaxes || 0) / 100);
      }
    } else {
      // Si no se ha seleccionado ningún tipo de impuesto, es necesario limpiar el valor de todos los campos
      // model.budget.amountExcludingTaxes = 0;
      model.budget.totalTaxes = 0;
      //model.budget.amountExcludingTaxes = 0;
    }
  }

  private updatedBudgetTaxTypeCSDA(model: any) {
    if (model.budget?.taxType?.identifier) {
      if (model.budget.taxType.identifier === '998<>TIPO_IMPUESTO') {
        model.budget.manualCalculation = true;
      }
      if (model.budget.taxType.identifier === '0<>TIPO_IMPUESTO') {
        model.budget.manualCalculation = false;
      }
    }
  }

  public enabledBudgetManualCalculationLotCSDA(model: any) {
    let isSeveralTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier === '998<>TIPO_IMPUESTO');

    let noTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier === '0<>TIPO_IMPUESTO');


    if (isSeveralTax || noTax) {
      return false;
    } else {
      return true;
    }

  }


  public updatedTaxRate(model: any) {

    let taxType = null;

    if (model?.budget?.taxType !== undefined && model.budget.taxType.identifier !== null) {
      taxType = model.budget.taxType.identifier;
    }

    if (taxType != null) {
      if (taxType != '998<>TIPO_IMPUESTO' && taxType != '999<>TIPO_IMPUESTO' && taxType != '1<>TIPO_IMPUESTO') {
        // si es exento de IVA, se limpia el valor del campo
        if (taxType === '0<>TIPO_IMPUESTO') {
          model.budget.taxRate = '';
        } else {
          // El campo se encuentra oculto, pero sigue grabando el valor por detras la
          // descripción del tipo de impuesto
          model.budget.taxRate = model.budget.taxType.properties.PORCENTAJE;

        }
      } else {
        // Si es Varios Tipos de IVA o Calculo Manual o IVA Incluido,
        // Tipo Impositivo, el que se ha introducido por pantalla
        model.budget.taxRate = '';
      }
    }
  }

  registerFunctions(frmConfig: FormConfig): void {
    // FUNCIONES PARA FICHA EXPEDIENTE CONTRATOS BASADOS //
    frmConfig.functions.push({
      identifier: 'isVisibleWorkProgramCSDA',
      fn: this.isVisibleWorkProgramCSDA
    });
    frmConfig.functions.push({
      identifier: 'isGoodsOrServicesCSDA',
      fn: this.isGoodsOrServicesCSDA
    });
    frmConfig.functions.push({
      identifier: 'isServicesCSDA',
      fn: this.isServicesCSDA
    });
    frmConfig.functions.push({
      identifier: 'lotNumberSDA',
      fn: this.lotNumberSDA
    });
    frmConfig.functions.push({
      identifier: 'lotDescriptionSDA',
      fn: this.lotDescriptionSDA
    });

    frmConfig.functions.push({
      identifier: 'isApportioned_SDA',
      fn: this.isApportioned_SDA
    });
    frmConfig.functions.push({
      identifier: 'visibleHarmonizedRegulationCSDA',
      fn: this.visibleHarmonizedRegulationCSDA
    });

    // FUNCIONES PARA FICHA EXPEDIENTE CONTRATOS BASADOS EN SDA //
    frmConfig.functions.push({
      identifier: 'updateBudgetDataCSDA',
      fn: this.updateBudgetDataCSDA.bind(this)
    });
    frmConfig.functions.push({
      identifier: 'updateTotalAmountCSDA',
      fn: this.updateTotalAmountCSDA.bind(this)
    });
    frmConfig.functions.push({
      identifier: 'enabledBudgetManualCalculationLotCSDA',
      fn: this.enabledBudgetManualCalculationLotCSDA
    });
  }
}
